import { render, staticRenderFns } from "./addCaigou.vue?vue&type=template&id=1d9cb8cd&scoped=true&"
import script from "./addCaigou.vue?vue&type=script&lang=js&"
export * from "./addCaigou.vue?vue&type=script&lang=js&"
import style0 from "./addCaigou.vue?vue&type=style&index=0&id=1d9cb8cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9cb8cd",
  null
  
)

export default component.exports